const NS = 'MediaListingPage';
const CLS = 'mediaListingPage';

import * as Api from '../../../../global/js/api';
import Handlebars from 'handlebars';
import { initPagination } from '../../../../global/js/pagination';

import { MediaItemWidget } from '../../../widgets/mediaItemWidget/js/mediaItemWidget';
import { BookmarkSquareWidget } from '../../../widgets/bookmarkSquareWidget/js/bookmarkSquareWidget';

export class MediaListingPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.sourceId = this.$element.data('sourceId');
		this.pageSize = this.$element.data('pageSize');
		this.getApi = this.$element.data('mediaApi');

		this.params = {
			sourceId: this.sourceId,
			pageNumber: 1,
			pageSize: this.pageSize
		};

		this.loadingSpinner = $('.loading-spinner');
		this.$itemsList = this.$element.find(`.tpl-content-list`);
		this.$pagination = this.$element.find(`.tpl-content-pagination`);

		this.view = 'list';
		this.setItemTemplate();
		this.getItems();

		// views change
		this.$element.on('click', '[data-view]', (e) => {
			let selectedView = $(e.currentTarget).data('view');
			this.$element.find('[data-view]').removeClass('active');
			$(e.currentTarget).addClass('active');
			if(this.view !== selectedView) {
				this.view = selectedView;
				this.getItems();
			}
		});

		// On select change
		this.$selects = this.$element.find(`.${CLS}-select`);
		this.$selects.on('change', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
				// Ensure that the filterKey does not match the current select value
				if(this.params[filterKey] !== $element.val()) {
					if(_.isNil($element.val()) || $element.val() === '') {
						delete this.params[filterKey];
					}
					else {
						this.params[filterKey] = $element.val();
					}

					this.params.pageNumber = 1;
					this.getItems(true);
				}
			}
		});

		// On Search change
		this.$inputSearch = this.$element.find(`.${CLS}-search-input`);
		this.$inputSearch.on('input', _.debounce((event) => {
			this.params['keyword'] = $(event.currentTarget).val().trim();

			this.params.pageNumber = 1;
			this.getItems(true);
		}, 250));

		// Clear Filters
		this.$btnClearFilters = this.$element.find(`.${CLS}-btn--clearFilters`);
		this.$btnClearFilters.on('click', () => {
			// Clear select values
			this.$selects.each((index, element) => {
				let $element = $(element);
				let filterKey = $element.data('filter-key');

				delete this.params[filterKey];
				$element.val('').change();
			});

			// Clear input values
			delete this.params['keyword'];
			this.$inputSearch.val('');

			this.params.pageNumber = 1;
			this.getItems(true);
		});

		this.$element.on('pagination.trigger', () => {
			this.getItems(true);
		});
	}

	getItems(scrollToTop = false) {
		let url = this.getApi;

		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		this.$itemsList.empty();
		this.loadingSpinner.addClass('is-active');

		Api.getApi(url).then((data) => {
			let items = data.results;
			if(items.length > 0) {
				this.$itemsList.html('<div class="row"></div>');
				let $itemsListingRow = this.$itemsList.find('.row');

				items.forEach((item) => {
					item.bookmarkSquareWidget = this.bookmarkSquareWidget;
					item.mods = (this.view === 'list') ? '' : 'mediaItemWidget--grid';

					let itemMarkup = this.itemTemplate(item);
					$itemsListingRow.append(`
						<div class="${(this.view === 'list') ? 'col-12' : 'col-12 col-md-6 col-lg-4'}">
							${itemMarkup}
						</div>
					`);

					new MediaItemWidget(this.$itemsList.find('.mediaItemWidget').last()[0]);
					new BookmarkSquareWidget(this.$itemsList.find('.bookmarkSquareWidget').last()[0]);
				});

				if(scrollToTop) {
					this.$element.trigger('pagination.scrollToTop');
				}

				initPagination(this.pageSize, data.totalCount, this.$pagination, this);

				if(this.view === 'list') {
					this.$element.removeClass('is-grid');
				}
				else {
					this.$element.addClass('is-grid');
				}
			}
			else {
				this.$itemsList.html(this.getEmptyResultTemplate());
			}

			this.loadingSpinner.removeClass('is-active');
		}, () => {
			this.loadingSpinner.removeClass('is-active');
		});
	}

	setItemTemplate() {
		let mediaItemPartial = require('../../../widgets/mediaItemWidget/tmpl/mediaItemWidget.hbs');
		Handlebars.registerPartial('mediaItemWidget', mediaItemPartial);

		let bookmarkPartial = require('../../../widgets/bookmarkSquareWidget/tmpl/bookmarkSquareWidget.hbs');
		Handlebars.registerPartial('bookmarkSquareWidget', bookmarkPartial);

		this.bookmarkSquareWidget = {
			wg: 'bookmarkSquareWidget',
			ns: 'BookmarkSquareWidget',
			bookmarkApi: this.$element.data('bookmarkApi'),
			unbookmarkApi: this.$element.data('unbookmarkApi'),
			bookmarkMessage: 'Item Saved!'
		};

		let template = `
			{{> mediaItemWidget
				wg="mediaItemWidget"
				ns="MediaItemWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);
	}

	getEmptyResultTemplate() {
		return `<p class="${CLS}-emptyResult col-12">Sorry, no media items found.</p>`;
	}
}
